export enum ErrorSurface {
  TOAST = 'toast',
  BANNER = 'banner',
  MODAL = 'modal',
  INLINE = 'inline',
}
